import React from "react";

import Home from "../components/homepage/home/home";

const HomeContainer = () => {
    return <Home />
}

export default HomeContainer;